common.View.create('canvas::editor.resizableMargin', {
    
    // Check mouse is within current element
    mouseWithinElement: false,

    // Current drag position (can be used for comparing against the current data)
    mousePositionOnDragDownX: 0,
    mousePositionOnDragDownY: 0,
    newMousePositionOnDragX: 0,
    newMousePositionOnDragY: 0,
    
    // Some properties that we need to check how much we have dragged
    bodyFontSize: 0,
    lastElementPadding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    currentElementPadding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },

    // Padding properties
    padding: {
        type: null,
        lastType: null, // This is for checking last padding position while being dragged
        steps: ['0', '1rem', '2rem', '4rem', '8rem'],
    },
    showPadding: {
        top: false,
        left: false,
        right: false,
        bottom: false,
    },
    showPaddingWhen: {
        doubleClick: true,
        click: false,
        hover: false,
    },

    isEditMode: true,

    onDOMLoad() {
        // Check if we ar ein admin at all times. Then check if there is an option to turn off resizableMargin
        if (!this.isAdmin() || typeof(this.element.data('resizableMargin')) !== 'undefined' 
            ? !this.element.data('resizableMargin')
            : false
        ) {
            return;
        }

        this.showPaddingWhen = this.element.data('show-padding-when') || this.showPaddingWhen;

        // Set edit mode based on show padding when
        if( this.showPaddingWhen.doubleClick || this.showPaddingWhen.click ) {
            this.isEditMode = false;
        }

        this.setProperties();
        this.mouseIsDown();
        this.mouseIsWithinElement();
        this.checkForDragElement();
        this.showIndicatorForMovingPadding();
    },

    isAdmin() {
        return $('body').hasClass('canvas::editor-website-Page');
    },

    setProperties() {
        // Set some properties that we need to calculate the current padding and the padding needed
        this.bodyFontSize = +$('html').css('font-size').replace('px', '');
        this.currentElementPadding.top = +this.element.css('padding-top').replace('px', '');
        this.currentElementPadding.left = +this.element.css('padding-left').replace('px', '');
        this.currentElementPadding.right = +this.element.css('padding-right').replace('px', '');
        this.currentElementPadding.bottom = +this.element.css('padding-bottom').replace('px', '');
    },

    mouseIsDown() {
        // Set click down on false on load
        sessionStorage.setItem('clickDown', sessionStorage.getItem('clickDown') || 'false');

        this.element
            .on('mousedown', () => {
                sessionStorage.setItem('clickDown', 'true');
            }).on('mouseleave', (mouse) => {
                let mouseLeave = this.mouseLeaveElement(mouse);

                if( mouseLeave === 'left' || mouseLeave === 'right' ) {
                    sessionStorage.setItem('clickDown', 'false');
                }
            }).on('mouseup', () => {
                sessionStorage.setItem('clickDown', 'false');
            });
    },

    mouseIsWithinElement() {
        this.element
            .on('mouseenter', () => {
                this.mouseWithinElement = true;
            })
            .on('mouseleave', () => {
                this.mouseWithinElement = false;
            });
    },

    mouseLeaveElement(mouse)
    {
        let elemBounding = this.element.get(0).getBoundingClientRect();

        let top = Math.abs(elemBounding.top - mouse.pageY),
            left = Math.abs(elemBounding.left - mouse.pageX),
            right = Math.abs(elemBounding.right - mouse.pageX),
            bottom = Math.abs(elemBounding.bottom - mouse.pageY);

        let min = Math.min(top, bottom, left, right);

        switch(min) {
            case top:
                return 'top';
            case left:
                return 'left';
            case right:
                return 'right';
            case bottom:
                return 'bottom';
        }
    },

    showIndicatorForMovingPadding() {
        this.element
            // Set box-shadow for indicating padding
            .on('mousemove',  async (e) => {
                // Check if element may show padding
                if (!this.isEditMode) {
                    return;
                }

                // Click is being held down; could be on other element; in this case we don't show the padding and resize cursor
                if (sessionStorage.getItem('clickDown') === 'true') {
                    return;
                }

                // Since the wrong value may be taken due to loading longer, reset the properties
                await this.setProperties();
                await this.updateBoxShadowStyling(e);
                await this.updateCursorOnHover(e);
            }).on('mouseout', (e) => {
                // If not dragging
                if (!this.padding.lastType) {
                    this.resetShowPadding();
                    this.updatePadding();

                    this.unsetResizeCursor();
                }
            }).on('mouseleave', (e) => {
                // If not dragging
                if (!this.padding.lastType) {
                    this.resetShowPadding();
                    this.updatePadding(true);

                    this.unsetResizeCursor();
                }
            });
    },

    resetShowPadding() {
        this.showPadding = {
            top: false,
            left: false,
            right: false,
            bottom: false,
        };
    },

    setPaddingType(e)
    {
        this.padding.type = this.checkPaddingType(this.element, e) || this.padding.lastType;
    },

    async updateCurrentBoxShadow(e) {
        // Set the position of padding clicked
        this.setPaddingType(e);

        // Set padding from element
        this.resetShowPadding();

        if( this.isEditMode ) {
            this.showPadding[this.padding.type] = true;

            // Set cursor
            this.setResizeCursor();
        } else {
            // Reset cursor
            this.unsetResizeCursor();
        }

        // Set a border that will display the padding on the element
        this.boxShadowSizeBadge();
    },

    setResizeCursor() {
        // Set cursor to resize when dragging or hovering within padding
        document.body.style.cursor = ['top', 'bottom'].includes(this.getPaddingType()) ? 'ns-resize' : 'ew-resize';
    },

    unsetResizeCursor() {
        // Set cursor to default when not dragging or hovering within padding
        document.body.style.cursor = 'unset';
    },

    async updateBoxShadowStyling(e)
    {
        // Set the position of padding clicked
        this.setPaddingType(e);

        // Set a border that will display the padding on the element
        this.boxShadowSizeBadge();
    },

    updateCursorOnHover(e) {
        // Set cursor to resize when dragging or hovering within padding
        if (this.padding.lastType || this.withinPadding(this.element, e)) {
            this.setResizeCursor();

            this.showPadding[this.padding.type] = true;
        } else {
            this.unsetResizeCursor();

            this.showPadding[this.padding.type] = false;
        }

        this.updatePadding();
    },

    updatePadding(reset = false)
    {
        let elements = this.element.find('> .paddingFrameWrap > [class*="boxShadowSizing"]');

        // Loop all elements and set opacity based on padding type
        elements.each((index, element) => {
            let $element = $(element);

            if ($element.hasClass('boxShadowSizing-' + (this.padding.type || this.padding.lastType))
                && this.showPadding[(this.padding.type || this.padding.lastType)]
            ) {
                $element.css('opacity', 1);
            } // Reset opacity when we are not editing 
            else if (reset) {
                $element.css('opacity', 0);
            }
        });
    },

    setBoxShadowFromPadding(showItemOnHover = false) {
        let boxShadow = '';

        // Get padding from element and create appropriate box-shadow based on that
        for (let element in this.currentElementPadding) {
            boxShadow += 'inset ';

            // Add padding as box-shadow string based on padding position
            if (['top', 'bottom'].includes(element)) {
                boxShadow += '0 ' + (element === 'bottom' ? '-' : '') + this.currentElementPadding[element] + 'px';
            } else if (['left', 'right'].includes(element)) {
                boxShadow += (element === 'right' ? '-' : '') + this.currentElementPadding[element] + 'px 0';
            }

            boxShadow += ' hsl(0deg 0% 0% / 10%),';
        }

        // Set box-shadow on element
        this.element.css('box-shadow', boxShadow.substring(0, boxShadow.length - 1));
    },

    boxShadowSizeBadge() {
        let $boxShadowWrapper = this.element.find('> .paddingFrameWrap').length 
            ? this.element.find('> .paddingFrameWrap') 
            : $('<div class="paddingFrameWrap"></div>').appendTo(this.element);

        // Get padding from element and create appropriate box-shadow based on that
        for (let element in this.currentElementPadding) {
            // Get or create box shadow element
            let boxShadowPosition = 'boxShadowSizing-' + element,
                $boxShadowSizeElement = this.element.find('> .paddingFrameWrap > .' + boxShadowPosition).length
                    ? this.element.find('> .paddingFrameWrap > .' + boxShadowPosition)
                    : $('<div class="' + boxShadowPosition + ' absolute transition-colors ease-in-out grid leading-none place-items-center text-gray-500 text-sm z-50"></div>')
                        .appendTo($boxShadowWrapper);

            // Apply background
            $boxShadowSizeElement.css('background-image', 'linear-gradient(135deg, #b6c4fa 3.13%, #c7d2fe 3.13%, #c7d2fe 50%, #b6c4fa 50%, #b6c4fa 53.13%, #c7d2fe 53.13%, #c7d2fe 100%)');
            $boxShadowSizeElement.css('background-size', '22.63px 22.63px');

            // Hide element when not dragging
            if (!this.padding.lastType) {
                $boxShadowSizeElement.css('opacity', this.showPadding[element] ? 1 : 0);
            }

            // Set sizing based on current padding
            if (element === 'top') {
                $boxShadowSizeElement.addClass('top-0 left-0 right-0')
                    .css('height', (this.currentElementPadding.top || 5) + 'px')
                    .text(this.currentElementPadding.top + 'px');
            } else if (element === 'left') {
                $boxShadowSizeElement.addClass('top-0 left-0 bottom-0')
                    .css('width', (this.currentElementPadding.left || 5) + 'px')
                    .text(this.currentElementPadding.left + 'px');
            } else if (element === 'right') {
                $boxShadowSizeElement.addClass('top-0 right-0 bottom-0')
                    .css('width', (this.currentElementPadding.right || 5) + 'px')
                    .text(this.currentElementPadding.right + 'px');
            } else {
                $boxShadowSizeElement.addClass('bottom-0 left-0 right-0')
                    .css('height', (this.currentElementPadding.bottom || 5) + 'px')
                    .text(this.currentElementPadding.bottom + 'px');
            }
        }
    },

    checkForDragElement() {
        if (this.showPaddingWhen.doubleClick) {
            this.element.on('dblclick', async (e) => {

                // Check if element may show padding
                if (this.withinPadding(this.element, e)) {
                    this.isEditMode = !this.isEditMode;
                    
                    await this.setProperties();
                    await this.updateCurrentBoxShadow(e);
                }

            });
        }

        else if (this.showPaddingWhen.click) {
            this.element.on('click', async (e) => {

                // Check if element may show padding
                if (this.withinPadding(this.element, e)) {
                    this.isEditMode = !this.isEditMode;

                    await this.setProperties();
                    await this.updateCurrentBoxShadow(e);
                }

            });
        }

        // Set drag element on mousedown
        this.element.on('mousedown', (e) => {
            this.dragElement(e);
        });
    },

    dragElement(e) {
        // Element must first be clicked to edit padding with dragging, so we add a class to check if that is the case
        if( !this.isEditMode) {
            return;
        }

        // Set the position of padding clicked
        this.padding.lastType = this.checkPaddingType(this.element, e);

        // Is click within padding? Aka user wants to change padding on canvas block?
        if (this.withinPadding(this.element, e)) {
            this.dragMouseDown(e);
        }
    },

    dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();

        // Add transitions
        this.element.css('transition', 'padding 0.24s cubic-bezier(0.22, 0.61, 0.36, 1) 0s');

        // Get the mouse cursor position at startup:
        this.mousePositionOnDragDownX = e.clientX;
        this.mousePositionOnDragDownY = e.clientY;

        // On mouse up action
        $(document).on('mouseup.resizableMargin mouseleave.resizableMargin', (e) => {
            this.closeDragElement(e);
        });

        // Set some properties that we need to calculate the current padding and the padding needed
        this.setProperties();

        // Set padding for comparisons later on; remove reference by using $.extend
        this.lastElementPadding = $.extend(true, {}, this.currentElementPadding);

        // Call a function whenever the cursor moves:
        $(document).on('mousemove.resizableMargin', (e) => {
            this.elementDrag(e);
        });
    },

    elementDrag(e) {
        e = e || window.event;
        e.preventDefault();

        this.isDragging = true;

        // Set new cursor position
        this.newMousePositionOnDragX = e.clientX;
        this.newMousePositionOnDragY = e.clientY;

        // Get difference between the current drag amount
        let currentElementPaddingInRem = this.lastElementPadding[this.getPaddingType()] / this.bodyFontSize,
            amountDraggedYAxis = this.getDraggedAmountFromDirection(this.newMousePositionOnDragY, this.mousePositionOnDragDownY, 'y') / this.bodyFontSize,
            amountDraggedXAxis = this.getDraggedAmountFromDirection(this.newMousePositionOnDragX, this.mousePositionOnDragDownX, 'x') / this.bodyFontSize,
            newPadding = currentElementPaddingInRem + (
                ['top', 'bottom'].includes(this.getPaddingType()) ? amountDraggedYAxis : amountDraggedXAxis
            );

        // Get closest padding in steps from dragged amount
        let closestPadding = this.padding.steps.map(el => parseInt(el)).reduce((prev, curr) => {
            return (Math.abs(curr - newPadding) < Math.abs(prev - newPadding) ? curr : prev);
        });

        // Set padding on our element
        this.element.css('padding-' + this.getPaddingType(), closestPadding + 'rem');

        // Keep showing the current padding on the element
        this.updatePadding();

        // Update padding in our variables
        this.currentElementPadding[this.getPaddingType()] = Math.floor(closestPadding * this.bodyFontSize);

        // Set a border that will display the padding on the element
        this.boxShadowSizeBadge();
    },

    closeDragElement() {
        // Remove transitions
        this.element.css('transition', '');
        this.padding.lastType = null;

        this.isDragging = false;

        // Stop moving when mouse button is released:
        $(document).off('mouseup.resizableMargin');
        $(document).off('mouseleave.resizableMargin');
        $(document).off('mousemove.resizableMargin');

        // Mouse is not within current element?
        // This means the user is done dragging; so we can then remove the box-shadow
        if (!this.mouseWithinElement) {
            this.updatePadding();
        }

        // Check if anything changed, if not, we don't need to save anything
        if (this.currentElementPadding.top === this.lastElementPadding.top &&
            this.currentElementPadding.left === this.lastElementPadding.left &&
            this.currentElementPadding.right === this.lastElementPadding.right &&
            this.currentElementPadding.bottom === this.lastElementPadding.bottom
        ) {
            return;
        }

        // Here we can then save the padding on the item
        let ajaxCall = $.ajax({
            url: '/canvas/admin/modules/canvas/save-padding',
            method: 'POST',
            data: {
                padding: this.currentElementPadding,
                canvasBlockId: this.element.data('canvas-block-id'),
            }
        });

        ajaxCall.done((response) => {
            // Check if we have a response
            if (response.success) {
                if(!this.element.data('vue-instance')) {
                    console.error('Vue instance not found on element, probably edited too fast while still saving');
                    return;
                }

                // Update the canvas block with the new padding
                this.element.data('vue-instance').canvasBlock.options = {
                    ...this.element.data('vue-instance').canvasBlock.options,
                    ...response.options
                }
            }
        });
    },

    withinPadding(element, e) {
        // Get paddings from element
        let padding = this.getElementPadding(element, e);

        // Compare if event is within padding
        return !((padding.x > padding.pLeft && padding.x < padding.width - padding.pRight) &&
            (padding.y > padding.pTop && padding.y < padding.height - padding.pBottom));
    },

    checkPaddingType(element, e) {
        // Get paddings from element
        let padding = this.getElementPadding(element, e);

        // Check where the click is
        if (padding.x > padding.pLeft && !(padding.x < padding.width - padding.pRight)) {
            return 'right';
        } else if (padding.x < padding.width - padding.pRight && !(padding.x > padding.pLeft)) {
            return 'left';
        } else if (padding.y < padding.height - padding.pBottom && !(padding.y > padding.pTop)) {
            return 'top';
        } else if (padding.y > padding.pTop && !(padding.y < padding.height - padding.pBottom)) {
            return 'bottom';
        }

        return false;
    },

    getElementPadding(element, e) {
        let jsElement = element.get(0) || element,
            style;

        return {
            style: style = window.getComputedStyle(jsElement, null),
            pTop: parseInt(style.getPropertyValue('padding-top')) || 5,
            pRight: parseFloat(style.getPropertyValue('padding-right')) || 5,
            pLeft: parseFloat(style.getPropertyValue('padding-left')) || 5,
            pBottom: parseFloat(style.getPropertyValue('padding-bottom')) || 5,
            width: jsElement.offsetWidth,
            height: jsElement.offsetHeight,
            x: e.pageX - $(jsElement).offset().left,
            y: e.pageY - $(jsElement).offset().top
        }
    },

    getDraggedAmountFromDirection(newMousePosition, mousePositionOnDragDown, direction) {
        // Is vertical?
        if (direction === 'y') {
            // Is from top?
            if (this.getPaddingType() === 'top') {
                return newMousePosition - mousePositionOnDragDown;
            }

            // Is from bottom?
            return mousePositionOnDragDown - newMousePosition;
        }

        // Is horizontal?
        if (this.getPaddingType() === 'left') {
            return newMousePosition - mousePositionOnDragDown;
        }

        return mousePositionOnDragDown - newMousePosition;
    },

    getPaddingType() {
        return this.padding.type || this.padding.lastType;
    }

});